/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-25 00:15:25
 * @LastEditTime: 2022-02-09 22:38:06
 * @LastEditors: chenguobiao
 */
import { strictFetch } from './http'
import qs from 'qs'
// 申请考级时获取信息
export async function postGetAvailableActivityList(data) {
  return strictFetch({
    url: '/index/getAvailableActivityList',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 购买生成订单
export async function postBuyProduct(data) {
  return strictFetch({
    url: '/index/buyProduct',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 报名活动生成订单
export async function postEnrollActivity(data) {
  return strictFetch({
    url: '/index/enrollActivity',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 校验活动是否可报名
export async function postJudgeEnrollActivity(data) {
  return strictFetch({
    url: '/index/judgeEnrollActivity',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 获取当前订单信息
export async function postGetOrderInfo(data) {
  return strictFetch({
    url: '/index/getOrderInfo',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 生成二维码
export async function postCreateQRCode(data) {
  return strictFetch({
    url: '/index/createQRCode',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 分页获取我的订单信息
export async function postGetMyOrderInfo(data) {
  return strictFetch({
    url: '/index/getMyOrderInfo',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 判断当前用户申请/取消退赛和申请重考/取消权限
export async function postCheckApplyQuitAppealPermission(data) {
  return strictFetch({
    url: '/index/checkApplyQuitAppealPermission',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 前台用户申请退赛
export async function postApplyQuit(data) {
  return strictFetch({
    url: '/index/applyQuit',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 前台用户申请重考
export async function postApplyAppeal(data) {
  return strictFetch({
    url: '/index/applyAppeal',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 前台用户取消退赛
export async function postCancelQuit(data) {
  return strictFetch({
    url: '/index/cancelQuit',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 前台用户取消申请重考
export async function postCancelAppeal(data) {
  return strictFetch({
    url: '/index/cancelAppeal',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 联系客服详细查询
export async function postGetOneContact(data) {
  return strictFetch({
    url: '/contact/getOne',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 取消申请
export async function postCancelMyOrder(data) {
  return strictFetch({
    url: '/index/cancelMyOrder',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 订单状态更新
export async function postOrderSave(data) {
  return strictFetch({
    url: '/order/save',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 点击办证操作下单接口
export async function postBuyCertificate(data) {
  return strictFetch({
    url: '/index/buyCertificate',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 前台获取当前证书信息
export async function postGetCertificateInfo(data) {
  return strictFetch({
    url: '/index/getCertificateInfo',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 前台用户申请办证操作
export async function postApplyCertificate(data) {
  return strictFetch({
    url: '/index/applyCertificate',
    method: 'POST',
    data: qs.stringify(data)
  })
}
